// extracted by mini-css-extract-plugin
export default {"header":"style_header__Wa5b2","interactive":"style_interactive__VcpSM","danger":"style_danger__j35Cc"};